module.exports = __webpack_public_path__ + "assets/a3b4a638aa14d4f7e9a2949c398a6f41.mp3";